import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ApiNewsService } from '../../../../services/news/api/api-news.service';
import { AlertsService } from '../../../../services/alerts.service';
import { ModalsService } from '../../../../services/modals.service';
import { LanguagesService } from '../../../../services/languages/languages.service';
import { NewsPredefinedTranslation } from '../../../../models/news/news-predefined-translation.model';
import { NewsPredefinedTranslationEditModalComponent } from '../news-predefined-translation-edit-modal/news-predefined-translation-edit-modal.component';
import { NewsPredefinedTranslationAddModalComponent } from '../news-predefined-translation-add-modal/news-predefined-translation-add-modal.component';

@Component({
  selector: 'app-news-predefined-translations-modal',
  templateUrl: './news-predefined-translations-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, NewsPredefinedTranslationEditModalComponent, NewsPredefinedTranslationAddModalComponent]
})
export class NewsPredefinedTranslationsModalComponent {

  @ViewChild('modal') modal!: ModalDirective;
  @ViewChild('translationEditModal') translationEditModal!: NewsPredefinedTranslationEditModalComponent;
  @ViewChild('translationAddModal') translationAddModal!: NewsPredefinedTranslationAddModalComponent;

  newsPredefinedId: number = 0;
  newsPredefinedName: string = '';
  translations: NewsPredefinedTranslation[] = [];

  private callbackChanged: (() => void) | undefined;

  constructor(
    private apiNewsService: ApiNewsService,
    private alertsService: AlertsService,
    private modalsService: ModalsService,
    public languagesService: LanguagesService
  ) {}

  getLanguageIso(languageId: number): string {
    return this.languagesService.languages.find(l => l.languageId === languageId)?.languageIso ?? String(languageId);
  }

  show(newsPredefinedId: number, newsPredefinedName: string, translations: NewsPredefinedTranslation[], callbackChanged?: () => void): void {
    this.newsPredefinedId = newsPredefinedId;
    this.newsPredefinedName = newsPredefinedName;
    this.translations = [...translations];
    this.callbackChanged = callbackChanged;
    this.modal.show();
  }

  onClickAddTranslation(): void {
    this.translationAddModal.show(this.newsPredefinedId, this.translations, () => {
      if (this.callbackChanged) { this.callbackChanged(); }
    });
  }

  onClickEditTranslation(translation: NewsPredefinedTranslation): void {
    const languageIso = this.getLanguageIso(translation.languageId);
    this.translationEditModal.show(this.newsPredefinedId, languageIso, translation, () => {
      if (this.callbackChanged) { this.callbackChanged(); }
    });
  }

  onClickDeleteTranslation(translation: NewsPredefinedTranslation): void {
    this.modalsService.showConfirmModal(() => {
      this.apiNewsService.deleteNewsPredefinedTranslation(this.newsPredefinedId, translation.languageId).then(
        () => {
          this.alertsService.displayAlertSuccess('Translation deleted !');
          if (this.callbackChanged) { this.callbackChanged(); }
        }, error => {
          this.alertsService.displayAlertError('Error deleting translation : ' + error);
        }
      );
    });
  }
}
